import React, { useEffect, useState } from "react";
import _ from "lodash";
import { ResponsiveLine } from "@nivo/line";
import { Row } from "antd";

const PitchGraph = ({ data }) => {
  const [dataSet, setDataSet] = useState();
  const orderDataByYear = (data) => {
    let uniqDataInfo = getOnlyUniqIds(data);
    let dates = [];
    uniqDataInfo &&
      uniqDataInfo.map((graphArray) => {
        // prendo tutte le date, ordinate e uniche
        graphArray.data.map((g) => dates.push(g.x));
        dates.sort((a, b) => a - b).filter((val) => val !== undefined);
        dates = _.uniq(dates);
        setDataSet(uniqDataInfo);
        //return data;
      });
    // cerco se l'array del grafico contiene tutte le date, altrimenti le aggiungo
    uniqDataInfo.map((grapArray) => {
      dates.forEach((date) => {
        const founded = grapArray.data
          .sort((a, b) => a.x - b.x)
          .find((g) => g.x === date);
        if (!founded) {
          grapArray.data.push({ x: date, y: 0 });
          grapArray.data.sort((a, b) => a.x - b.x);
        }
      });
      setDataSet(uniqDataInfo);
    });
  };

  useEffect(() => {
    orderDataByYear(data);
  }, [data]);

  /**
   * Sometimes the pitch graph data have the same id (like "Agenzia Eventi")
   * So we need to merge the info from duplicates on one uniq element
   * @param {*} response
   * @returns
   */
  const getOnlyUniqIds = (response = []) => {
    let newResponse = [];
    if (response?.length > 0) {
      newResponse = response.reduce((accumulator, cur) => {
        var id = cur.id;
        var found = accumulator.find((elem) => {
          return elem.id == id;
        });
        if (found) cur.data.forEach((curObj) => found.data.push(curObj));
        else accumulator.push(cur);
        return accumulator;
      }, []);
    }
    return newResponse;
  };

  // one legend row per series: grow the chart so none are clipped
  const seriesCount = dataSet?.length || 0;
  const chartHeight = Math.max(400, seriesCount * 20 + 70);

  // thin the x axis: label round years only, and never two labels closer
  // than 3 slots (the point scale spaces years by position, not by value)
  const years = _.uniq(
    (dataSet || []).flatMap((serie) => serie.data.map((d) => d.x)),
  )
    .filter((x) => x != null && Number.isFinite(Number(x)))
    .sort((x, y) => x - y);
  const xTickValues = [];
  let lastIndex = -3;
  years.forEach((year, index) => {
    if (Number(year) % 5 === 0 && index - lastIndex >= 3) {
      xTickValues.push(year);
      lastIndex = index;
    }
  });

  return (
    <div className="pitchGraph">
      <Row style={{ height: `${chartHeight}px`, width: "100%" }}>
        <ResponsiveLine
          data={dataSet}
          margin={{ top: 10, right: 240, bottom: 50, left: 50 }}
          xScale={{ type: "point" }}
          yScale={{ type: "linear" }}
          enableGridX={false}
          lineWidth={2}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            orient: "bottom",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            tickValues: xTickValues,
            legend: "year",
            legendOffset: 36,
            legendPosition: "middle",
          }}
          axisLeft={{
            orient: "left",
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendPosition: "middle",
            format: (e) => (Math.floor(e) === e ? e : ""),
          }}
          theme={{
            fontSize: 12,
            textColor: "#666",
            grid: { line: { stroke: "#eee" } },
          }}
          useMesh={true}
          colors={{ scheme: "spectral" }}
          pointSize={6}
          pointColor={{ theme: "background" }}
          pointBorderWidth={2}
          pointBorderColor={{ from: "serieColor" }}
          pointLabelYOffset={-12}
          legends={[
            {
              anchor: "top-right",
              direction: "column",
              itemWidth: 190,
              itemHeight: 20,
              itemTextColor: "#666",
              symbolSize: 10,
              symbolShape: "circle",
              translateX: 230,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemTextColor: "#000",
                  },
                },
              ],
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default PitchGraph;
